import { EDecision } from '@if/core/types'
import { CancelOutlined as CancelOutlinedIcon, Check as CheckIcon, Search as SearchIcon } from '@mui/icons-material'
import { useTheme } from '@mui/material'

interface Props {
  decision?: EDecision
}

const DecisonIcon = ({ decision }: Props) => {
  const theme = useTheme()
  return (
    <>
      {(decision === EDecision.ManualRevision || decision === EDecision.Pending || decision === EDecision.Error) && (
        <SearchIcon color="warning" sx={{ fontSize: 60, mb: theme.spacing(1) }} />
      )}

      {decision === EDecision.Approved && <CheckIcon color="success" sx={{ fontSize: 60, mb: theme.spacing(1) }} />}

      {decision === EDecision.Refused && (
        <CancelOutlinedIcon color="error" sx={{ fontSize: 60, mb: theme.spacing(1) }} />
      )}
    </>
  )
}

export default DecisonIcon
